const BRAND = {
  VISA: "VISA",
  MASTERCARD: "MASTERCARD",
  AMEX: "AMEX",
  DISCOVER: "DISCOVER",
  DINERS: "DINERS",
  JCB: "JCB",
  UNIONPAY: "UNIONPAY",
  ELO: "ELO",
  HIPERCARD: "HIPERCARD",
  CREDIT_CARD: "CREDIT_CARD",
};

const defs = [
  {
    brand: BRAND.ELO,
    test: (n) =>
      /^(40117[89]|431274|438935|451416|457393|4576|504175|5067|509|627780|636(297|368)|650[3-5]|65165[2-9]|6550)\d*$/.test(
        n
      ),
    panLengths: [16],
    cvcLength: 3,
    group: "4-4-4-4",
  },
  {
    brand: BRAND.VISA,
    test: (n) => /^4\d{0,}$/.test(n),
    panLengths: [13, 16, 19],
    cvcLength: 3,
    group: "4-4-4-4/4-4-4-7",
  },
  {
    brand: BRAND.AMEX,
    test: (n) => /^3[47]\d{0,}$/.test(n),
    panLengths: [15],
    cvcLength: 4,
    group: "4-6-5",
  },
  {
    brand: BRAND.DISCOVER,
    test: (n) => /^(6011|65|64[4-9])\d*$/.test(n),
    panLengths: [16, 19],
    cvcLength: 3,
    group: "4-4-4-4",
  },
  {
    brand: BRAND.DINERS,
    test: (n) => /^3(0[0-5]|09|6|[89])\d*$/.test(n),
    panLengths: [14, 16],
    cvcLength: 3,
    group: "4-6-4",
  },
  {
    brand: BRAND.JCB,
    test: (n) => /^35(2[89]|[3-8]\d)\d*$/.test(n),
    panLengths: [16, 19],
    cvcLength: 3,
    group: "4-4-4-4",
  },
  {
    brand: BRAND.UNIONPAY,
    test: (n) => /^62[0-5]\d*$/.test(n),
    panLengths: [16, 17, 18, 19],
    cvcLength: 3,
    group: "4-4-4-4",
  },
  {
    brand: BRAND.HIPERCARD,
    test: (n) => /^(606282|3841)\d*$/.test(n),
    panLengths: [16, 19],
    cvcLength: 3,
    group: "4-4-4-4",
  },
  {
    brand: BRAND.MASTERCARD,
    test: (n) =>
      /^(5[1-5]\d{0,}|22(2[1-9]|[3-9]\d)|2[3-6]\d{0,2}|27[01]\d|2720)\d*$/.test(n),
    panLengths: [16],
    cvcLength: 3,
    group: "4-4-4-4",
  },
];

export function getCardInfo(cardNumber) {
  const number = String(cardNumber || "").replace(/\D/g, "");
  if (!number) {
    return {
      brand: BRAND.CREDIT_CARD,
      panLengths: [],
      cvcLength: 3,
      group: undefined,
    };
  }

  for (const d of defs) {
    if (d.test(number)) {
      return {
        brand: d.brand,
        panLengths: d.panLengths,
        cvcLength: d.cvcLength,
        group: d.group,
      };
    }
  }

  return {
    brand: BRAND.CREDIT_CARD,
    panLengths: [],
    cvcLength: 3,
    group: undefined,
  };
}

export const getCardBrand = (cardNumber) => getCardInfo(cardNumber).brand;

export const cardBrandCodeMap = {
    PIX: 16,
    BOLETO: 17,
    CREDIT_CARD: 191,
    VISA: 190,
    MASTERCARD: 191,
    AMEX: 189,
    ELO: 199,
    AURA: 9999,
    JCB: 195,
    DINERS: 192,
    DISCOVER: 9999,
    HIPERCARD: 193,
    SOROCRED: 187,
    CABAL: 188,
    CREDSYSTEM: 9999,
    BANESCARD: 9999,
    CREDZ: 9999,
};